import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, JOBS } from "../../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${EMPLOYER}/${JOBS}`; 

export const fetchJob = async (uuid) => {
  const url = `${API_BASE_URL}/${uuid}`;
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    // console.log("API data", data)
    return data;
  } catch (error) {
    // console.log("error", error);
    return error;
  }
};


export const updateJob = async (uuid, jobData) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${API_BASE_URL}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(jobData),
    });

    if (!response.ok) {
      throw new Error("Error updating job : " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job : " + error.message);
  }
};
